const DEFAULT_GEOLOCATION_SERVICE_URL = 'https://geolocation.services.cargoking.com'

export const getGeolocationServiceUrl = ({
  configuredUrl,
  environment,
  nodeEnv,
}: {
  configuredUrl?: string
  environment?: string
  nodeEnv?: string
} = {}) =>
  configuredUrl ??
  (environment === 'dev' || (!environment && nodeEnv === 'development')
    ? 'https://geolocation.services.dev.cargoking.com'
    : DEFAULT_GEOLOCATION_SERVICE_URL)
